/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Pain_Points_DescriptionInputs */

const en_meta_pain_points_description = /** @type {(inputs: Meta_Pain_Points_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Six processes AI automation takes on: customer support questions, lead and sales follow-ups, document processing and data extraction, handoffs, reports and knowledge.`)
};

const lv_meta_pain_points_description = /** @type {(inputs: Meta_Pain_Points_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seši procesi, kuros palīdz AI: klientu jautājumi, pārdošanas sarunu turpināšana, dokumentu apstrāde un datu ieguve, darba nodošana, atskaites un uzņēmuma zināšanas.`)
};

/**
* | output |
* | --- |
* | "Six processes AI automation takes on: customer support questions, lead and sales follow-ups, document processing and data extraction, handoffs, reports and k..." |
*
* @param {Meta_Pain_Points_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_pain_points_description = /** @type {((inputs?: Meta_Pain_Points_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Pain_Points_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_pain_points_description(inputs)
	return en_meta_pain_points_description(inputs)
});